import { gql } from "@apollo/client";

export const LOAD_SPACE_MEMBERS = gql`
  query LoadSpaceMembers(
    $mrn: String!
    $first: Int
    $after: String
    $orderBy: MembershipOrder
    $query: String
  ) {
    space(mrn: $mrn) {
      members(
        first: $first
        after: $after
        orderBy: $orderBy
        query: $query
        identityTypeFilter: [USER]
      ) {
        edges {
          node {
            roles {
              title
              mrn
            }
            identity {
              mrn
              name
              ... on User {
                email
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        totalCount
      }
      id
      mrn
    }
  }
`;
